import PropTypes from 'prop-types';
import {GuarantorWarningMessage, StartDateWarningMessage} from '../Review/ReviewMessages';
import Button from '@material-ui/core/Button';
import React from 'react';
import {EXCLUDE_ALFA_CASE_STATUS, excludeAlfaCaseStatusErrorMessage} from '../Constants/constants';
import {TooltipWarningButton} from './TooltipWarningButton';
import {FormattedMessage, useIntl} from 'react-intl';
import {useNavigate} from 'react-router-dom';

export const CreateEnvelopButton = ({row, userBranchCode}) => {
    const countryCode = userBranchCode.slice(0, 2);
    const intl = useIntl();
    const isInvalidDate = (startDate) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0)
        const formattedStartDate = new Date(startDate);
        formattedStartDate.setHours(0, 0, 0, 0)

        return formattedStartDate < currentDate;
    }
    const navigate = useNavigate();

    const isInvalidStartDate = (countryCode === 'ES' || countryCode === 'PT') && isInvalidDate(row.startDate);
    const hasGuarantorRole = countryCode === 'DE' && row.hasGuarantor
    const handleClick = () => {
        navigate(`/e-sign/${row.quoteNumber}`, { state: row });
    };

    const buttonMap = {
        [true]: (

            <Button
                color="primary"
                onClick={handleClick}
                size="small"
                style={{ fontSize: 12 }}
                variant="contained"
            >
                <FormattedMessage id={'labels.CREATE_ENVELOPE'} />
            </Button>
        ),
        [EXCLUDE_ALFA_CASE_STATUS.includes(row.alfaCaseStatus)]: (
            <TooltipWarningButton
                warningMessage={intl.formatMessage({id: excludeAlfaCaseStatusErrorMessage})}
            />
        ),
        [isInvalidStartDate]: (
            <TooltipWarningButton
                warningMessage={intl.formatMessage({id: StartDateWarningMessage})}
            />
        ),
        [hasGuarantorRole]: (
            <TooltipWarningButton
                warningMessage={intl.formatMessage({id: GuarantorWarningMessage})}
            />
        )
    }
    return buttonMap.true;
};

CreateEnvelopButton.propTypes = {
    userBranchCode: PropTypes.string,
    row: PropTypes.object
};
